import 'react';
import { RoundButton } from '../../button/components/roundButton/index.js';
import '@babel/runtime/helpers/extends';
import { jsx } from '@emotion/react';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../../../constants/breakpoints/index.js';
import '../../../constants/grid/index.js';
import '../../../constants/mediaQueries/index.js';
import '../../../constants/boxShadows/primary.js';
import '../../../constants/boxShadows/secondary.js';
import ArrowLeftIcon from '../../../icons/icons/arrowLeftIcon.js';
import ArrowRightIcon from '../../../icons/icons/arrowRightIcon.js';
import Style from './style.js';

var Arrow = _ref => {
  var {
    bottomRightAlignedArrows = false,
    disabled = false,
    next = false,
    onClick = () => undefined,
    prev = false
  } = _ref;
  var ArrowContainerComponent = bottomRightAlignedArrows ? Style.BottomRightAlignedArrowContainer : Style.ArrowContainer;
  return jsx(ArrowContainerComponent, {
    prev: prev,
    next: next,
    disabled: disabled
  }, prev && jsx(RoundButton, {
    buttonType: bottomRightAlignedArrows ? 'primary' : 'action',
    disabled: disabled,
    icon: jsx(ArrowLeftIcon, null),
    onClick: onClick,
    "aria-label": "Previous item"
  }), next && jsx(RoundButton, {
    buttonType: bottomRightAlignedArrows ? 'primary' : 'action',
    disabled: disabled,
    icon: jsx(ArrowRightIcon, null),
    onClick: onClick,
    "aria-label": "Next item"
  }));
};

export { Arrow as default };
